import { API_ENDPOINTS } from "./endpoints";
import { requestJson, toArray } from "./httpClient";

const normalizeEmployee = (employee) => ({
    ...employee,
    phoneNumber: employee.phoneNumber || employee.phone_number || "",
    email: employee.email || "",
    blocked: Boolean(employee.blocked),
    roles: Array.isArray(employee.roles)
        ? employee.roles
        : [
            ...(employee.purchase ? ["BUYING"] : []),
            ...(employee.sales ? ["SELLER"] : [])
        ]
});

export const fetchEmployees = async (options = {}) => {
    const data = await requestJson(options.admin ? API_ENDPOINTS.admin.employees : API_ENDPOINTS.employees.list, {
        headers: options.headers
    });
    return toArray(data).map(normalizeEmployee);
};

const buildEmployeeBody = ({ id, name, phoneNumber, email, password, roles }) => ({
    ...(id !== undefined ? { id } : {}),
    name,
    phone_number: phoneNumber,
    email,
    ...(password ? { password } : {}),
    roles
});

export const createEmployee = async ({ name, phoneNumber, email, password, roles }, options = {}) => {
    return requestJson(options.admin ? API_ENDPOINTS.admin.employees : API_ENDPOINTS.employees.list, {
        method: "POST",
        body: buildEmployeeBody({ name, phoneNumber, email, password, roles }),
        headers: options.headers
    });
};

export const updateEmployee = async ({ id, name, phoneNumber, email, password, roles }, options = {}) => {
    return requestJson(options.admin ? API_ENDPOINTS.admin.employees : API_ENDPOINTS.employees.list, {
        method: "PUT",
        body: buildEmployeeBody({ id, name, phoneNumber, email, password, roles }),
        headers: options.headers
    });
};

export const setEmployeeBlocked = async (id, blocked) => {
    return requestJson(
        blocked
            ? API_ENDPOINTS.admin.blockEmployee(id)
            : API_ENDPOINTS.admin.unblockEmployee(id),
        { method: "PATCH" }
    );
};
